import { createContext, useContext, useEffect, useState } from "react";
import { loginApi, meApi, setToken, clearToken, getToken } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    (async () => {
      if (getToken()) {
        try { setUser(await meApi()); } catch { clearToken(); }
      }
      setChecking(false);
    })();
  }, []);

  const login = async (email, password) => {
    const data = await loginApi(email, password);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { clearToken(); setUser(null); };

  return <AuthContext.Provider value={{ user, checking, login, logout }}>{children}</AuthContext.Provider>;
};
